/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_No_Token_PromiseInputs */

const en_pol_no_token_promise = /** @type {(inputs: Pol_No_Token_PromiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep never stores your subscription token`)
};

const id_pol_no_token_promise = /** @type {(inputs: Pol_No_Token_PromiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep tidak pernah menyimpan token langganan kamu`)
};

/**
* | output |
* | --- |
* | "Bystep never stores your subscription token" |
*
* @param {Pol_No_Token_PromiseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_no_token_promise = /** @type {((inputs?: Pol_No_Token_PromiseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_No_Token_PromiseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_no_token_promise(inputs)
	return en_pol_no_token_promise(inputs)
});